import { render } from "./verification.vue?vue&type=template&id=7a5cc24c&scoped=true"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"

import "./verification.vue?vue&type=style&index=0&id=7a5cc24c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5cc24c"]])

export default __exports__